import React from 'react';
import {
  marketMetaLine,
  marketTitle,
  scheduleLabel,
  teamOdds,
  teamProbability,
} from './nxlUtils';

function MarketCard({ market, selected, onSelect }) {
  return (
    <button
      className={`nxl-market-row ${selected ? 'selected' : ''}`}
      onClick={() => onSelect(market)}
    >
      <div>
        <strong>{marketTitle(market)}</strong>
        <span>{scheduleLabel(market)}</span>
        <small className="nxl-market-meta">
          {market.division}
          {marketMetaLine(market) ? ` • ${marketMetaLine(market)}` : ''}
        </small>
      </div>

      <div className="nxl-market-probs">
        <span>{teamProbability(market, 'team_a')}</span>
        <span>{teamOdds(market, 'team_a')}</span>
        <span>{teamProbability(market, 'team_b')}</span>
        <span>{teamOdds(market, 'team_b')}</span>
      </div>
    </button>
  );
}

export default MarketCard;